<template>
    <div>
        <!-- <div v-if="authUserPermission['service-group-view']"> -->
            <base-header class="pb-6">
                <div class="row align-items-center py-4">
                    <div class="col-lg-6 col-7">
                        <h6 class="h2 text-white d-inline-block mb-0"></h6>
                    </div>      
                </div>
            </base-header>
            <div class="container-fluid mt--6">
                <div class="row">
                    <div class="col-md-6">
                        <div class="card mb-4">
                            <div class="card-header mt--4 mb--4">
                                <div class="row">
                                    <div class="col-7">
                                        <h3 class="mb-0">{{ tt('service_category') }}</h3>
                                    </div>
                                    <div class="col-5">
                                        <div class="form-group">
                                            <input type="text" class="form-control form-control-sm text-center border-radius-20" v-model="table.search" :placeholder="tt('search_service_category')" v-on:keyup="filter"/>                            
                                        </div>
                                    </div>
                                <!--  <div class="col text-right">
                                        <base-button size="sm" type="default" @click="create" v-if="authUserPermission['service-group-create']">{{ tt('add_new') }}</base-button>
                                    </div> -->
                                </div>
                            </div>
                            <div>
                                <el-table height="400px" class="table-responsive table-flush" header-row-class-name="thead-light" :data="table.data" v-if="!onLoad" highlight-current-row @current-change="handleCurrentChange">
                                    <el-table-column :label="tt('code')" :prop="tt('code')" min-width="128px" sortable>
                                        <template v-slot="{row}">
                                            {{row.code}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column :label="tt('description')" :prop="tt('description')" min-width="205px" sortable>
                                        <template v-slot="{row}">
                                            {{row.description}}
                                        </template>
                                    </el-table-column>
                                    <!-- <el-table-column prop="action" width="100">
                                        <template v-slot="{row}">
                                            <el-dropdown trigger="click" class="dropdown" @command="handleTableAction" :hide-on-click="true">
                                                <span class="btn btn-sm btn-icon-only text-light">
                                                    <i class="fas fa-ellipsis-v mt-2"></i>
                                                </span>
                                                <el-dropdown-menu class="dropdown-menu dropdown-menu-arrow show" slot="dropdown">
                                                    <el-dropdown-item :command="{action:'relation', data:row.code}">{{ tt('relation') }}</el-dropdown-item>                             
                                                    <el-dropdown-item :command="{action:'edit', data:row.id}">{{ tt('edit') }}</el-dropdown-item>
                                                    <el-dropdown-item :command="{action:'remove', data:row.id}">{{ tt('delete') }}</el-dropdown-item>
                                                </el-dropdown-menu>
                                            </el-dropdown>
                                        </template>
                                    </el-table-column> -->
                                </el-table>
                                <page-loading v-else/>
                            </div>
                            <div class="card-footer pb-0 ">   
                                <span class="float-left">
                                    <base-pagination :page-count="table.page.last_page" v-model="table.page.current_page" @click.native="changePage(table.page.current_page)" size="sm"></base-pagination>
                                </span>                             
                                <span class="float-right">
                                    {{ tt('page_info', {size: (table.page.current_page - 1) * table.page.per_page + table.data.length, total: table.total}) }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="card mb-4">
                            <div class="card-header mt--4 mb--4">
                                <div class="row">
                                    <div class="col-12">
                                        <h3 class="mb-4">{{ tt('scope_of_supply') }}</h3>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <el-table height="400px" class="table-responsive table-flush" header-row-class-name="thead-light" :data="tableScopeOfSupply.data" v-if="!onLoadScopeOfSupply">
                                    <el-table-column :label="tt('sos_header')" :prop="tt('sos_header')" min-width="70px" sortable>
                                        <template v-slot="{row}">
                                            {{row.sos_header}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column :label="tt('sos_description')" :prop="tt('sos_description')" min-width="235px" sortable>
                                        <template v-slot="{row}">
                                            {{row.sos_description}}
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <page-loading v-else/>
                            </div>
                            <div class="card-footer"> 
                                <span class="float-left">
                                    <!-- <base-pagination :page-count="tableScopeOfSupply.page.last_page" v-model="tableScopeOfSupply.page.current_page" @click.native="changePage(tableScopeOfSupply.page.current_page)" size="sm" disabled></base-pagination> -->
                                </span>                               
                                <span class="float-right">
                                    {{ tt('page_info', {size: (tableScopeOfSupply.page.current_page - 1) * tableScopeOfSupply.page.per_page + tableScopeOfSupply.data.length, total: tableScopeOfSupply.total}) }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <validation-observer v-slot="{invalid}">
                <modal :show.sync="form.show">
                    <template slot="header">
                        <h5 class="modal-title">{{form.title}}</h5>
                    </template>
                    <div>
                        <base-alert type="danger" v-if="errorMessage">
                            <p><strong>{{ errorMessage.message }}</strong></p>
                            <div v-if="errorMessage.data.length != 0">
                                <span v-for="(message, idx) in errorMessage.data" :key="idx">
                                    {{ message[0] }}<br>
                                </span>
                            </div>
                        </base-alert>

                        <label class="form-control-label">{{ tt('holding') }} <span class="text-danger">*</span></label>
                        <base-input :name="tt('holding')" rules="required">
                            <el-select class="select-danger" v-model="serviceCategory.client_code" :placeholder="tt('choose_holding')">
                                <el-option class="select-danger" :value="hc['client_code']" :label="hc['client_code'] + ' - ' + hc['client_name']" :key="hc['client_code'] + ' - ' + hc['client_name']" v-for="hc in  holdingCode"></el-option>
                            </el-select>
                        </base-input>

                        <label class="form-control-label">{{ tt('code') }} <span class="text-danger">*</span></label>
                        <base-input :name="tt('code')" :placeholder="tt('code')" v-model="serviceCategory.code" rules="required|max:4"></base-input>

                        <label class="form-control-label">{{ tt('description') }} <span class="text-danger">*</span></label>
                        <base-input :name="tt('description')" :placeholder="tt('description')" v-model="serviceCategory.description" rules="required"></base-input>

                        <label class="form-control-label">{{ tt('account_category_refference') }} <span class="text-danger">*</span></label>
                        <base-input :name="tt('account_category_refference')" rules="required">
                            <el-select class="select-danger" v-model="serviceCategory.acc_cat_ref" :placeholder="tt('choose_account_category_refference')">
                                <el-option class="select-danger" :value="acr['acc_cat_ref']" :label="acr['acc_cat_ref'] + ' - ' + acr['acc_cat_ref_description']" :key="acr['acc_cat_ref'] + ' - ' + acr['acc_cat_ref_description']" v-for="acr in accountCategoryRefference"></el-option>
                            </el-select>
                        </base-input>
                    </div>
                    <template slot="footer">
                        <base-button type="secondary" @click="form.show = false">{{ tt('close') }}</base-button>
                        <base-button type="primary" v-on:click="save" :disabled="btnSave.onLoading || invalid">
                            <span v-if="btnSave.onLoading"><i class="fas fa-spinner fa-spin"></i> {{ tt('please_wait') }}</span>
                            <span v-else>
                                <span v-if="form.add">{{ tt('add') }}</span>
                                <span v-else>{{ tt('edit') }}</span>
                            </span>
                        </base-button>
                    </template>
                </modal>
            </validation-observer>
            
            <!-- <validation-observer v-slot="{invalid}"> -->
                <modal :show.sync="formRelation.show">
                    <template slot="header">
                        <h5 class="modal-title">{{ tt('create_relation') }}</h5>
                    </template>
                    <div>
                        <div class="row">
                            <el-autocomplete
                            class="inline-input col-md-10"
                            v-model="dataRelation.service_group_code"
                            :fetch-suggestions="querySearch"
                            :placeholder="tt('choose_account_catalog_refference')"
                            @select="handleSelect"
                            size="small"
                            ></el-autocomplete>
                            <base-button type="dark" size="sm" @click="addRelation">{{ tt('add') }}</base-button>
                        </div>
                        <br>
                        <table class="table table-sm table-hover" v-if="!onLoadRelation">
                            <tbody>
                                <tr v-for="(item, index) in serviceGroup" :key="index">
                                    <td>{{item.code}} - {{item.description}}</td>
                                    <td class="text-right"><i class="fa fa-trash text-danger" @click="deleteRelation(item.id)"></i></td>
                                </tr>
                            </tbody>
                        </table>
                        <page-loading v-else/>
                    </div>
                    <template slot="footer">
                        <base-button type="secondary" @click="formRelation.show = false">{{ tt('close') }}</base-button>
                    </template>
                </modal>
            <!-- </validation-observer> -->
        <!-- </div>
        <unathorize v-else/> -->
    </div>
</template>
<script>
    import {mapState} from 'vuex'
    import Api from '@/helpers/api';
    import serviceCategory from '@/services/master/serviceCategory.service';
    import holdingCode from '@/services/master/holdingCode.service';
    import accountCategoryRefference from '@/services/master/accountCategoryRefference.service';
    import priceControl from '@/services/master/priceControl.service';
    import serviceGroup from '@/services/master/serviceGroup.service';
    
    export default {
        data() {
            return {             
                onLoad: true,
                onLoadRelation: true,
                loadTimeout: null,  
                btnSave: {
                    onLoading: false
                },   
                links: [],
                dataRelation: {},
                form: {
                    add: true,
                    title: this.tt('create_service_category'),
                    show: false
                },      
                formRelation: {
                    show: false
                }, 
                table: {
                    search: '',                    
                    total: 0,
                    data: [],
                    page: {
                        current_page: 1,
                        per_page: 100,
                    },
                }, 
                onLoadScopeOfSupply: false,
                tableScopeOfSupply: {
                    search: '',                    
                    total: 0,
                    data: [],
                    page: {
                        current_page: 1,
                        per_page: 100,
                    },
                },    
                errorMessage: null,    
                serviceCategory: {},
                holdingCode: {},
                accountCategoryRefference: {},
                priceControl: {},
                serviceGroup: [],
                relationCode: null,
            }
        },
        computed: {
            ...mapState({
                authUserPermission :state => state.auth.userPermission
            }),
        },
        mounted() {
            this.get()
            this.getHoldingCode()
            this.getAccountCategoryRefference()
            this.getPriceControl()
            this.getserviceGroup()
            this.links = this.serviceGroup;
        },
        methods: {
            get() { 
                let context = this;               
                Api(context, serviceCategory.get_scat(this.table.page.current_page, {search: this.table.search})).onSuccess(function(response) {  
                    context.table.total = response.data.data.data.total;
                    context.table.data = response.data.data.data.data;  
                    context.table.page  = response.data.data.data;
                    context.onLoad = false;          
                }).onError(function(error) {                    
                    if (error.response.status == 404) {
                        context.table.data = [];
                        context.table.total = 0;
                        context.onLoad = false;
                    }
                })
                .call()
            },
            handleCurrentChange(val) {
                this.onLoadScopeOfSupply = true;
                this.tableScopeOfSupply.data = val.rel_scat_sos
                this.tableScopeOfSupply.total = val.rel_scat_sos.length
                this.onLoadScopeOfSupply = false;
            },
            getHoldingCode() {
                let context = this;               
                Api(context, holdingCode.get({per_page: 'none'})).onSuccess(function(response) {    
                    context.holdingCode = response.data.data.data.data;
                }).onError(function(error) {                    
                    if (error.response.status == 404) {
                        context.holdingCode = [];
                    }
                })
                .call()
            },
            getAccountCategoryRefference() {
                let context = this;               
                Api(context, accountCategoryRefference.get({per_page: 'none'})).onSuccess(function(response) {    
                    context.accountCategoryRefference = response.data.data.data.data;
                }).onError(function(error) {                    
                    if (error.response.status == 404) {
                        context.accountCategoryRefference = [];
                    }
                })
                .call()
            },
            getPriceControl() {
                let context = this;               
                Api(context, priceControl.get({per_page: 'none'})).onSuccess(function(response) {    
                    context.priceControl = response.data.data.data.data;
                }).onError(function(error) {                    
                    if (error.response.status == 404) {
                        context.priceControl = [];
                    }
                })
                .call()
            },
            getserviceGroup() {
                let context = this;               
                Api(context, serviceGroup.get({per_page: 'none'})).onSuccess(function(response) {    
                    response.data.data.data.data.forEach(function(item, index) {
                        context.serviceGroup[index] = {
                            'code': item['code'],
                            'value': item['code'] + ' - ' + item['description']
                        };
                    });
                }).onError(function(error) {                    
                    if (error.response.status == 404) {
                        context.serviceGroup = [];
                    }
                })
                .call()
            },
            filter() {
                this.onLoad = true;
                this.table.page.current_page = 1;
                clearTimeout(this.loadTimeout);
                this.loadTimeout = setTimeout(() => {
                    this.get()
                }, 100);
            },
            handleTableAction(command) {
                switch (command.action) {
                    case 'relation':
                            this.relation(command.data);
                        break;
                    case 'edit':
                            this.edit(command.data);
                        break;
                    case 'remove':
                            this.remove(command.data);
                        break;
                    default:
                        break;
                }
            },
            create() {
                this.errorMessage = null;
                this.form.add = true;
                this.form.title = this.tt('create_service_category');
                this.form.show = true;
                this.serviceCategory = {};
            },            
            edit(id) {
                this.errorMessage = null;
                let context = this;               
                Api(context, serviceCategory.show(id)).onSuccess(function(response) {
                    context.serviceCategory = response.data.data;
                    context.form.add = false;
                    context.form.title = context.tt('edit_service_category');
                    context.form.show = true;                          
                })
                .call()        
            },
            save() {                      
                this.btnSave.onLoading = true;
                let api = null;
                let context = this;

                if (this.form.add) {
                    api = Api(context, serviceCategory.create(this.serviceCategory));
                } else {{
                    api = Api(context, serviceCategory.update(this.serviceCategory.id, this.serviceCategory));
                }}
                api.onSuccess(function(response) {
                    context.get();
                    context.$notify({
                        message: response.data.message,                  
                        type: 'success',
                        verticalAlign: 'bottom', 
                        horizontalAlign: 'left'
                    });
                    context.form.show = false;
                }).onError(function(error) {                    
                    context.errorMessage = error.response.data;
                }).onFinish(function() {
                    context.btnSave.onLoading = false;   
                })
                .call();
            },
            remove(id) {
                this.confirmDialog(this.tt('confirm_delete')).then((result) => {
                    let context = this;
                    if (result.value) {
                        Api(context, serviceCategory.delete(id)).onSuccess(function(response) {
                            context.$notify({
                                message: response.data.message,
                                type: 'success',
                                verticalAlign: 'bottom', 
                                horizontalAlign: 'left'
                            });
                            context.get();
                        }).call();
                    }
                })
            },
            getRelation(code) {
                let context = this;
                Api(context, serviceCategory.service_group(code)).onSuccess(function(response) {
                    console.log(response)
                    context.serviceGroup = response.data.data;
                    context.onLoadRelation = false;
                }).onError(function(error) {                    
                    context.errorMessage = error.response.data;
                    context.serviceGroup = [];
                    context.onLoadRelation = false;
                }).onFinish(function() {
                })
                .call();
            },
            relation(code) { 
                this.onLoadRelation = true;
                this.relationCode = code;
                this.dataRelation.service_category_code = code;
                this.getRelation(code);
                this.formRelation.show = true;
            },
            addRelation() {
                let context = this;
                context.onLoadRelation = true;
                let fixDataRelation = {
                    'service_category_code': context.dataRelation.service_category_code,
                    'service_group_code': context.dataRelation.service_group_code.substr(0, context.dataRelation.service_group_code.search(' - '))
                };
                context.dataRelation.service_group_code = '';
                Api(context, serviceCategory.add_relation(fixDataRelation)).onSuccess(function(response) {
                    context.$notify({
                        message: response.data.message,                  
                        type: 'success',
                        verticalAlign: 'bottom', 
                        horizontalAlign: 'left'
                    });
                }).onError(function(error) {                    
                    context.errorMessage = error.response.data;
                }).onFinish(function() {
                    context.getRelation(context.relationCode);
                })
                .call();
            },
            deleteRelation(id) {
                let context = this;
                context.onLoadRelation = true;
                this.confirmDialog(this.tt('confirm_delete')).then((result) => {
                    let context = this;
                    if (result.value) {
                        Api(context, serviceCategory.delete_relation(id)).onSuccess(function(response) {
                            context.$notify({
                                message: response.data.message,
                                type: 'success',
                                verticalAlign: 'bottom', 
                                horizontalAlign: 'left'
                            });
                            context.getRelation(context.relationCode);
                        }).call();
                    }
                })
            },
            reset() {
                this.serviceCategory = {}
            },
            querySearch(queryString, cb) {
                var links = this.links;
                var results = queryString ? links.filter(this.createFilter(queryString)) : links;
                // call callback function to return suggestions
                cb(results);
            },
            createFilter(queryString) {
                return (link) => {
                  return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            loadAll(serviceGroup) {
                return serviceGroup;
            },
            handleSelect(item) {
                console.log(item);
            },
            changePage(page) {
                let context = this;
                context.onLoad = true;

                clearTimeout(this.loadTimeout);
                this.loadTimeout = setTimeout(() => {
                    this.get()
                }, 100);
            },
        },
    };
</script>
<style></style>
